import react from 'react'

export const CategoryContext = react.createContext(null)